import { OptionalFieldTypeTranslated } from '../../../types/Invoice';
import { TableColumn } from '../../table/DataTable.types';

export const columns = () =>
  [
    {
      accessor: 'isActive',
      name: 'page.optional-field.col-is-active',
      cellRenderer: (e) => (
        <input
          type={'checkbox'}
          checked={e.isActive}
          className={`w-4 h-4 text-center mt-1`}
          readOnly
        />
      ),
    },
    {
      accessor: 'isDefault',
      name: 'page.optional-field.col-is-default',
      cellRenderer: (e) => (
        <input
          type={'checkbox'}
          checked={e.isDefault}
          className={`w-4 h-4 text-center mt-1`}
          readOnly
        />
      ),
    },
    {
      accessor: 'value',
      name: 'page.optional-field.col-value',
    },
    {
      accessor: 'language',
      name: 'page.optional-field.col-language',
    },
    {
      accessor: 'fieldType',
      name: 'page.optional-field.col-field-type',
      translateEnum: OptionalFieldTypeTranslated,
    },
  ] as TableColumn[];
